const assetModules = import.meta.glob('./assets/**/*.(svg|png|jpg|jpeg|gif|mp4|webm)', { eager: true, query: '?url', import: 'default' });

window.require = function require(path) {
  let normalizedPath = path;

  normalizedPath = normalizedPath
    .replace(/^\.\.\/\.\.\/\.\.\/\.\.\//, './')
    .replace(/^\.\.\/\.\.\/\.\.\//, './')
    .replace(/^\.\.\/\.\.\//, './')
    .replace(/^\.\//, './');

  if (!normalizedPath.startsWith('./assets/')) {
    const idx = normalizedPath.indexOf('assets/');
    if (idx !== -1) {
      normalizedPath = './' + normalizedPath.substring(idx);
    }
  }

  for (const [key, value] of Object.entries(assetModules)) {
    if (key.endsWith(normalizedPath.replace('./assets/', './assets/')) || key.includes(normalizedPath.split('/').slice(-1)[0])) {
      return value;
    }
  }

  const fileName = normalizedPath.split('/').pop();
  for (const [key, value] of Object.entries(assetModules)) {
    if (key.endsWith('/' + fileName)) {
      return value;
    }
  }

  console.warn('[require-shim] Could not resolve:', path);
  return path;
};
